export default __webpack_public_path__ + "static/media/lynn-profile.df6986ce.jpg";